import Konva from 'konva';
import * as _ from 'lodash';
import { HGroup } from '../area/HGroup';
import { Rectangle } from '../area/Rectangle';
import { VLine } from '../area/VLine';
import { SC_Input } from '../input/SC_Input';
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { AreaFinder } from '../roof/areaFinder';
import { SC_Beam } from '../roof/SC_Beam';
import { Global } from '../utilities/global';
import { Statics } from '../utilities/statics';
import { Intersections } from './findIntersections';
import { HProfile_find } from './hProfile';
import { MountingSystem } from './MountingSystem';
import { Sol50 } from './Sol50';
import { Sol50OnRoof } from './Sol50OnRoof';
import { SubFrameIn } from './subFrameIn';
import { DrawVProfile } from './vProfile';

export class SubFrame {
    static cutlistGroup: any = [];
    static isProfileCutEnabled = false;

    static drawHprofileKonva(obj: any) {
        setTimeout(
            () => {
                var temp = new Konva.Line({
                    points: [...obj],
                    fill: Sol50OnRoof.uiHProfileCol,
                    closed: true,
                });
                DrawRoofForPanel.subframeGroup.add(temp);
                // console.log(window.location);

                if (!window.location.href.includes('itemList') && temp) {
                    temp?.draw();
                }
            },
            SC_Input.iBeamType == SC_Beam.PURLIN ? 200 : 0,
        );
    }

    static drawVprofileKonva(obj: any) {
        var temp = new Konva.Line({
            points: [...obj],
            fill: Sol50OnRoof.uiVProfileCol,
            closed: true,
        });
        DrawRoofForPanel.subframeGroup.add(temp);
        // console.log(window.location);
        if (!window.location.href.includes('itemList') && temp) {
            temp?.draw();
        }
    }

    static drawFramework() {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            SubFrameIn.drawFramework();
        } else {
            HProfile_find();
            SubFrame.drawHProfile();
            if (SC_Input.bBeam) {
                DrawVProfile.drawVProfile();
                if (SC_Input.iBeamType == SC_Beam.RAFTER) {
                    // setTimeout(() => {
                    Intersections.RoofHook_draw();
                    // }, 10);
                } else if (SC_Input.iBeamType == SC_Beam.PURLIN) {
                    // setTimeout(() => {
                    Intersections.drawStoSch();
                    // }, 10);
                }
            }
        }

        // console.log(getAllInString())
    }

    static drawHProfile() {
        var nHalfProfHeight: number = Sol50OnRoof.nHProfileHeight / 2;

        const minCutLength = 10;
        let pname: any = '';
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            pname = 'SOL-50 Premium XXL-Horizontalprofil 2m schwarz'; // SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M ||
            (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 13)
        ) {
            pname = 'SOL-50 Standard XXL-Horizontalprofil 2m pressblank'; // SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M ||
            (SC_Input.iMountSys > 12 && SC_Input.iMountSys < 15)
        ) {
            pname = 'SOL-50 Standard XXL-Horizontalprofil 4m pressblank'; // SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            pname = 'SOL-50 Premium XXL-Horizontalprofil 4m schwarz'; // SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            pname = 'SOL-50 Standard Horizontalendkappe VE10 schwarz';
        }
        this.cutlistGroup = [];
        let lengthArr: any = [];
        //e = not taken into consideration
        //l = start of line
        //r = length of line
        //y = y axis of line
        Global.aHProfile.forEach((item: any) => {
            const x1 = item.l;
            const y1 = item.y - nHalfProfHeight;
            const x2 = item.r;
            const y2 = item.y - nHalfProfHeight;
            const x3 = item.r;
            const y3 = item.y + nHalfProfHeight;
            const x4 = item.l;
            const y4 = item.y + nHalfProfHeight;
            SubFrame.drawHprofileKonva([x1, y1, x2, y2, x3, y3, x4, y4]);

            if (SubFrame.isProfileCutEnabled) {
                //draw profile cutting
                let x: number = 0;

                //next profile cut position
                let y: number = 0;

                //ys= y start position
                //ye = y end position
                //x = x axis position
                const ys = item.y - 10;
                const ye = item.y + 10;
                const length = item.r;
                x = item.l + Sol50OnRoof.nHProfileLen;
                y = item.l + Sol50OnRoof.nHProfileLen;
                let len: number = 0;
                len = Sol50OnRoof.nHProfileLen;
                // const obj1 = {
                // 	name: pname ,
                // 	cut: len +"m"
                // };
                //this.cutlistGroup.push(obj1);
                //for small length profiles

                if (y < length) {
                    var greenLine = new Konva.Line({
                        points: [x, ys, x, ys, x, ye, x, ye],
                        stroke: '#1F6451',
                        strokeWidth: 15,
                        lineCap: 'round',
                        lineJoin: 'round',
                    });

                    DrawRoofForPanel.subframeGroup.add(greenLine);
                }

                let prevlen = 0;

                //prevlen = x;
                //len = x - prevlen;
                //lengthArr.push(len);
                while (y < length) {
                    prevlen = x;
                    x = x + Sol50OnRoof.nHProfileLen;

                    y = x + Sol50OnRoof.nHProfileLen;
                    if (y > length) {
                        const nextlength = length - x;

                        if (
                            nextlength < Sol50OnRoof.cutProfileLen &&
                            nextlength > 0
                        ) {
                            const toMinus =
                                Sol50OnRoof.cutProfileLen - nextlength;
                            x = x - toMinus;
                            //len = len - toMinus;
                            //prevlen = x;
                            //x= x + Sol50OnRoof.nHProfileLen + toMinus;

                            //break;
                        }
                    }
                    if (x < length) {
                        var greenLine = new Konva.Line({
                            points: [x, ys, x, ys, x, ye, x, ye],
                            stroke: '#1F6451',
                            strokeWidth: 15,
                            lineCap: 'round',
                            lineJoin: 'round',
                        });

                        DrawRoofForPanel.subframeGroup.add(greenLine);
                    }

                    len = x - prevlen;

                    lengthArr.push(len);
                }
                let prev = x - Sol50OnRoof.nHProfileLen;
                if (length - prev > 0) {
                    //if(x > Sol50OnRoof.nHProfileLen){
                    //	len = Sol50OnRoof.nHProfileLen;
                    //}else{
                    len = length - prev;
                    //}

                    if (len > Sol50OnRoof.nHProfileLen) {
                        lengthArr.push(Sol50OnRoof.nHProfileLen);
                        len = len - Sol50OnRoof.nHProfileLen;
                    }
                    lengthArr.push(len);
                }

                //end draw profile cutting
            }
        });

        this.cutlistGroup = [];
        if (lengthArr.length > 0) {
            let map: any = {};

            for (var j = 0; j < lengthArr.length; j++) {
                var len = lengthArr[j].toFixed(2);
                if (Sol50OnRoof.nHProfileLen - len < 1) {
                    len = Sol50OnRoof.nHProfileLen;
                }
                if (map[len]) {
                    map[len] = map[len] + 1;
                } else {
                    map[len] = 1;
                }
            }
            const kk: any = Object.keys(map);
            const vv: any = Object.values(map);
            if (vv[0] > vv[1]) {
                const factor: any = vv[0] / vv[1];
                SC_Input.horizontalLengthCovered =
                    factor * parseFloat(kk[0]) + parseFloat(kk[1]);
            } else {
                const factor: any = vv[1] / vv[0];
                SC_Input.horizontalLengthCovered =
                    factor * parseFloat(kk[1]) + parseFloat(kk[0]);
            }

            for (const [key, value] of Object.entries(map)) {
                //const key2 = Math.abs(parseFloat(key) * 100).toFixed(0);
                var cutval = value + ' * ' + key + ' cm';
                const obj = {
                    name: pname,
                    cut: cutval,
                };
                this.cutlistGroup.push(obj);
            }
        }

        //print cutlist
        Global.cutlistGroup = this.cutlistGroup;
    }

    static drawVProfile() {
        var i: number;
        var nSparrenLeft: number;
        var iSparrenIndex: number;
        var hgroupTmp: HGroup;
        var nAbstandH: number = 1; //TFE
        var nAbstandHCurrent: number;
        var nAbstandHLast: number;
        var sModWidth: string;
        var nCurrentX: number;
        var nX: number;
        var nXMax: number;
        var vprofileTmp: VLine;
        var aTmp: any[];
        var iCurrent: number;
        var iLen: number;
        var aCol: any[];
        var sRange: string;
        var iModIndex: number;
        var nModW: number, nModH: number;
        var nCurX: number, nCurY: number;
        var rTmp: Rectangle;
        var nModWSpace: number;
        var iRaftCnt: number;
        aTmp = new Array();
        var nBeamDist1 = SC_Input.nBeamDist1 + 100;

        for (i = 0; i < Global.panelRows.length; i++) {
            hgroupTmp = Global.panelRows[i];
            if (hgroupTmp.x < nBeamDist1) {
                nX = nBeamDist1;
                iSparrenIndex = 0;
                nCurrentX = nX;
            } else {
                nX = hgroupTmp.x - nBeamDist1;
                iSparrenIndex = parseInt('' + nX / SC_Input.nBeamDist) + 1;
                nCurrentX = iSparrenIndex * SC_Input.nBeamDist + nBeamDist1;
            }
            nXMax = hgroupTmp.x + hgroupTmp.width;
            rTmp = new Rectangle();
            nModH = hgroupTmp.height;
            nModW = hgroupTmp.width;
            nCurY = hgroupTmp.y;
            //sparrenweise
            nModWSpace = nModW + Sol50.nHorizontalAbstand;
            sModWidth = nModW.toString();
            iRaftCnt = 0;
            nAbstandHLast = Number.MAX_VALUE;
            nAbstandHCurrent = Number.MAX_VALUE;
            while (nCurrentX < nXMax) {
                iModIndex = Math.floor((nCurrentX - hgroupTmp.x) / nModWSpace);
                rTmp.x = iModIndex * nModWSpace + hgroupTmp.x;
                rTmp.y = nCurY;
                rTmp.width = nModW;
                rTmp.height = nModH;
                sRange = !Global.toggleBoundaryArea
                    ? AreaFinder.getAreaByModule(rTmp)
                    : 'h';
                nAbstandH = Statics.oSpanWidthMax[sRange][sModWidth];
                if (nAbstandH == -1) {
                    iRaftCnt = 0;
                    nCurrentX += SC_Input.nBeamDist;
                    continue;
                } else if (nAbstandH > SC_Input.nBeamDist) {
                    nAbstandH =
                        Math.floor(nAbstandH / SC_Input.nBeamDist) *
                        SC_Input.nBeamDist;
                }
                if (nAbstandHLast == nAbstandH) {
                    if (nAbstandHCurrent < nAbstandHLast) {
                        nAbstandHLast = nAbstandH;
                        nCurrentX += SC_Input.nBeamDist;
                        nAbstandHCurrent += SC_Input.nBeamDist;
                        continue;
                    }
                } else if (nAbstandHLast * 2 == nAbstandH) {
                    //doppelt
                    if (nAbstandHCurrent < nAbstandH) {
                        nAbstandHLast = nAbstandH;
                        nCurrentX += SC_Input.nBeamDist;
                        nAbstandHCurrent += SC_Input.nBeamDist;
                        continue;
                    }
                }
                nAbstandHLast = nAbstandH;
                vprofileTmp = new VLine(null);
                vprofileTmp.t = hgroupTmp.y;
                vprofileTmp.b = hgroupTmp.y + hgroupTmp.height;
                vprofileTmp.x = nCurrentX;
                aTmp.push(vprofileTmp);
                iRaftCnt++;
                nCurrentX += SC_Input.nBeamDist;
                nAbstandHCurrent = SC_Input.nBeamDist;
            }
            //letztes Modul bei doppeltem Abstand
            if (
                nAbstandH > SC_Input.nBeamDist &&
                nAbstandH == nAbstandHCurrent
            ) {
                nCurrentX -= SC_Input.nBeamDist;
                vprofileTmp = new VLine(null);
                vprofileTmp.t = hgroupTmp.y;
                vprofileTmp.b = hgroupTmp.y + hgroupTmp.height;
                vprofileTmp.x = nCurrentX;
                aTmp.push(vprofileTmp);
            }
        }
        if (aTmp.length == 0) {
            return;
        }
        Sol50OnRoof.aVProfile = new Array();
        //sort by x
        // aTmp.sortOn("x", Array.NUMERIC);
        aTmp = _.sortBy(aTmp, 'x');
        iLen = aTmp.length;
        iCurrent = 0;
        while (iCurrent < iLen) {
            aCol = Sol50OnRoof.VProfile_getCol(aTmp, iLen, iCurrent);
            iCurrent += aCol.length;
            // aCol.sortOn("t", Array.NUMERIC);
            aCol = _.sortBy(aCol, 't');
            Sol50OnRoof.VProfile_optimize(aCol);
        }
        // correct length

        for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
            vprofileTmp = Sol50OnRoof.aVProfile[i];
            //correct by cover trim and vertical overlap
            vprofileTmp.t -= Sol50OnRoof.nVPOverLapTop;
            vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;
            const adj = Sol50OnRoof.nVProfileHeight;
            SubFrame.drawVprofileKonva([
                vprofileTmp.x - adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.b,
                vprofileTmp.x - adj / 2,
                vprofileTmp.b,
            ]);
        }
    }
}
